import {Component, Vue} from 'vue-property-decorator'
import {compact, cloneDeep} from 'lodash'
import assetsDict from '@/assets-dict'

/**
 * @mixin
 */
@Component
export default class Assets extends Vue {

  get __rootPath(): string {
    return ''
  }

  get __assetsDict(): object {
    return cloneDeep(assetsDict)
  }

  /**
   * Return __rootPath/img/name
   * @param name
   */
  img(name): string {
    const path = compact(['img', name]).join('/')
    const checkAvailable = this.checkAvailable(path)
    if(checkAvailable) {
      return [this.__rootPath, path].join('/')
    }
    return ''
  }

  checkAvailable(path) {
    const available = path?.split('/')?.reduce((o,i) => o?.[i], this.__assetsDict)
    if(!available) {
      throw new Error(`assets-dict 디렉토리에 ${path} 파일이 정의되어있지 않습니다.`)
    }
    return available
  }
}
